import * as React from "react";

import DeprecatedIconButton from "@v1/components/designSystem/button/IconButton";
import { useLogAnalytics } from "@v2/hooks/useLogAnalytics";
import { docs } from "@v2/utils/docs";
import { Book } from "lucide-react";

export const MetricsDocButton: React.FC = () => {
  const analytics = useLogAnalytics();

  return (
    <DeprecatedIconButton
      icon={<Book size={16} />}
      size="base"
      variant="secondary"
      onClick={() => {
        analytics("analytics.definitions.open", {});
      }}
      to={docs.abTesting.metricDefinitions}
      target="_blank"
      rel="noopener noreferrer"
      tooltipText="Metric Definitions"
    />
  );
};
